// extracted by mini-css-extract-plugin
var _1 = "Container-modulecontainer__Dja49";
var _2 = "Container-modulecontent__hwVr6";
var _3 = "Container-modulelabel__Du0gD";
export { _1 as "container", _2 as "content", _3 as "label" }
